import { fetcher } from "helpers/fetcher";

import { TDeleteStaffInsuranceReq, TDeleteStaffInsuranceRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteEmployeeInsurance = async (
  payload: TDeleteStaffInsuranceReq
) => {
  return await fetcher<
    TDeleteStaffInsuranceRes,
    TDeleteStaffInsuranceReq["data"]
  >(ENDPOINT.USER.DELETE_EMPLOYEE_INSURANCE, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.USER.DELETE_EMPLOYEE_INSURANCE.version,
      [API_HEADER.USER_ID]: payload.idUser,
    },
  });
};

export const mutationDeleteEmployeeInsurance = async (
  payload: TDeleteStaffInsuranceReq
) => {
  return (await deleteEmployeeInsurance(payload)).data.message;
};

mutationDeleteEmployeeInsurance._key = (payload: TDeleteStaffInsuranceReq) => [
  ENDPOINT.USER.DELETE_EMPLOYEE_INSURANCE.url,
  payload,
];
